import HTTP from "@/_helpers/http";
import { LIVETRADES__API } from "@/_helpers/urls";
import { LIVETRADES__MUTATIONS } from "../mutation-types";
import { LIVETRADES__ACTIONS } from "../action-types";

const state = {
  trades: [],
  chartData: [],
  dashboardLiveTradesData: {
    total: 0,
    totalProfit: 0,
    totalVolume: 0
  },
  pagination: {
    total: 0,
    perPage: 10,
    currentPage: 1,
    lastPage: 1
  },
  summaries: {
    totalProfit: 0,
    totalVolume: 0,
    totalEquity: 0
  },
  isLoading: false,
};

const getters = {};

const mutations = {
  [LIVETRADES__MUTATIONS.DASHBOARDLIVETRADES](state, data) {
    state.dashboardLiveTradesData = data?.data
  },

  [LIVETRADES__MUTATIONS.LIVETRADESCHARTDATA](state, data) {
    state.chartData = data?.data
  },

  [LIVETRADES__MUTATIONS.LIVETRADES](state, data) {

    // Update trades
    state.trades = data?.data?.trades || [];

    // Update pagination
    state.pagination = data?.data?.pagination || {
      total: 0,
      perPage: 10,
      currentPage: 1,
      lastPage: 1
    };

    // Update summaries
    state.summaries = data?.data?.summaries || {
      totalProfit: 0,
      totalVolume: 0,
      totalEquity: 0
    };

    state.lastUpdate = new Date().toISOString();
  },

  SET_LOADING(state, loading) {
    state.isLoading = loading;
  },
};

const actions = {
  async [LIVETRADES__ACTIONS.DASHBOARDLIVETRADES]({ commit, state }) {
    try {
      const response = await HTTP().get(LIVETRADES__API.DASHBOARDLIVETRADES);

      commit(LIVETRADES__MUTATIONS.DASHBOARDLIVETRADES, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [LIVETRADES__ACTIONS.LIVETRADESCHARTDATA]({ commit, state }) {
    try {
      const response = await HTTP().get(LIVETRADES__API.LIVETRADESCHARTDATA);

      commit(LIVETRADES__MUTATIONS.LIVETRADESCHARTDATA, response.data);
    } catch (error) {
      console.log(error);
    }
  },
  async [LIVETRADES__ACTIONS.LIVETRADES]({ commit, state }, parameter) {
    try {
      commit("SET_LOADING", true);

      const {
        page = 1,
        limit = 10,
        trading_account_type_id,
        search = "",
        duration
      } = parameter || {};

      const queryParams = new URLSearchParams({
        page: page.toString(),
        limit: limit.toString(),
        ...(trading_account_type_id && { trading_account_type_id }),
        ...(duration && { duration }),
        ...(search && { search })
      }).toString();


      const response = await HTTP().get(
        `${LIVETRADES__API.LIVETRADES}${queryParams ? `?${queryParams}` : ''}`
      );

      commit(LIVETRADES__MUTATIONS.LIVETRADES, response.data);

      commit("SET_LOADING", false);

    } catch (error) {
      console.error('Error fetching live trades:', error);
    }
  },
};

export default {
  namespaced: true,
  strict: process.env.NODE_ENV !== "production",
  state,
  getters,
  mutations,
  actions
};